// This file provides utilities to debug image loading in Ridley app

/**
 * Log the status of all image caches
 */
export const logImageCacheStatus = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    console.log('SessionStorage not available');
    return;
  }
  
  // Cache keys we're using
  const cacheKeys = [
    'ridleyImageCache',
    'ridleyBikeCategoryImages',
    'ridleyNovinkyImages'
  ];
  
  console.group('Image Cache Status');
  
  cacheKeys.forEach(key => {
    const cache = sessionStorage.getItem(key);
    if (!cache) {
      console.log(`${key}: Not found`);
      return;
    }
    
    try {
      const parsedCache = JSON.parse(cache);
      const imageCount = Object.keys(parsedCache).length;
      console.log(`${key}: ${imageCount} images cached`);
      
      // Log a sample of cached images
      const sampleSize = Math.min(3, imageCount);
      if (sampleSize > 0) {
        const sampleImages = Object.keys(parsedCache).slice(0, sampleSize);
        console.log(`Sample images: `, sampleImages);
      }
    } catch (error) {
      console.error(`Error parsing ${key} cache:`, error);
    }
  });
  
  console.groupEnd();
};

/**
 * Clear all image caches
 */
export const clearAllImageCaches = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    console.log('SessionStorage not available');
    return;
  }
  
  // Cache keys we're using
  const cacheKeys = [
    'ridleyImageCache',
    'ridleyBikeCategoryImages',
    'ridleyNovinkyImages'
  ];
  
  cacheKeys.forEach(key => {
    sessionStorage.removeItem(key);
  });
  
  console.log('All image caches cleared');
};

/**
 * Test if a specific image URL is cached
 */
export const isImageCached = (imageUrl) => {
  if (typeof window === 'undefined' || !window.sessionStorage || !imageUrl) {
    return false;
  }
  
  // Cache keys we're using
  const cacheKeys = [
    'ridleyImageCache',
    'ridleyBikeCategoryImages',
    'ridleyNovinkyImages'
  ];
  
  for (const key of cacheKeys) {
    const cache = sessionStorage.getItem(key);
    if (!cache) continue;
    
    try {
      const parsedCache = JSON.parse(cache);
      if (parsedCache[imageUrl]) {
        return true;
      }
    } catch (error) {
      console.error(`Error checking ${key} cache:`, error);
    }
  }
  
  return false;
};

const imageDebugUtils = {
  logImageCacheStatus,
  clearAllImageCaches,
  isImageCached
};

export default imageDebugUtils;
